module.exports = __webpack_public_path__ + "img/Diwali 3.8925bd08.jpeg";